import { lazy } from 'react';

const CalendarIntegrationModal = lazy(
  () =>
    import(
      'modules/StudentMeetingScheduler/components/CalendarIntegrationModal'
    ),
);

const OneOffMeetingModal = lazy(
  () => import('modules/StudentMeetingScheduler/components/OneOffMeetingModal'),
);

const MessageAttendeesModal = lazy(
  () =>
    import('modules/StudentMeetingScheduler/components/MessageAttendeesModal'),
);

export default {
  CALENDAR_INTEGRATION_MODAL: CalendarIntegrationModal,
  ONE_OFF_MEETING_MODAL: OneOffMeetingModal,
  MESSAGE_ATTENDEES_MODAL: MessageAttendeesModal,
};
